import { Carousel, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import ContentCard, { type ContentCardProps } from '../ContentCard/ContentCard';
import CardLoader from '../ContentCard/CardLoader/CardLoader';
import { ContentCardCarouselProps } from './types/propsTypes';
import styles from './ContentCardCarousel.module.scss';

const ContentCardCarousel = ({ cards, title, loading, loadingItems = 3, mode, variant }: ContentCardCarouselProps) => {
  const loaderItems = [...Array(loadingItems)].map((_, index) => index);
  const viewPortType = useBreakpoint() as Breakpoints;
  const dotsPaddingTop = viewPortType === Breakpoints.SM || viewPortType === Breakpoints.XS ? 16 : 32;
  return (
    <div className={styles['content-card-carousel']}>
      {cards.length > 0 && (
        <div className={styles['header']}>
          <div className={styles['title']}>{title}</div>
        </div>
      )}
      {loading && (
        <Carousel isTileCarousel dotsPaddingTop={dotsPaddingTop} className={styles['no-padding']}>
          {loaderItems.map((i) => (
            <CardLoader key={i} />
          ))}
        </Carousel>
      )}

      {!loading && (
        <Carousel isTileCarousel dotsPaddingTop={dotsPaddingTop} className={styles['no-padding']}>
          {cards?.map((item: ContentCardProps) => (
            <div key={item.title}>
              <ContentCard {...item} mode={mode} variant={variant} />
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default ContentCardCarousel;
